// eslint-disable-next-line import/no-extraneous-dependencies
import CryptoJS from 'crypto-js'

const SECRET_KEY =
  process.env.REACT_APP_STORAGE_ENCRYPTION_KEY ??
  'default_fallback_key_change_me'

const encrypt = (value: string): string => {
  return CryptoJS.AES.encrypt(value, SECRET_KEY).toString()
}

const decrypt = (cipherText: string): string | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    return decrypted || null
  } catch {
    return null
  }
}

export const secureSetItem = (key: string, value: string): void => {
  localStorage.setItem(key, encrypt(value))
}

export const secureGetItem = (key: string): string | null => {
  const raw = localStorage.getItem(key)
  if (!raw) return null
  const decrypted = decrypt(raw)
  // if decrypt fails (e.g. old plaintext data still in storage), return the raw value
  return decrypted !== null ? decrypted : raw
}

export const secureRemoveItem = (key: string): void => {
  localStorage.removeItem(key)
}

export const secureClearAll = (): void => {
  localStorage.clear()
}

export const secureSessionSetItem = (key: string, value: string): void => {
  sessionStorage.setItem(key, encrypt(value))
}

export const secureSessionGetItem = (key: string): string | null => {
  const raw = sessionStorage.getItem(key)
  if (!raw) return null
  const decrypted = decrypt(raw)
  return decrypted !== null ? decrypted : raw
}

export const secureSessionRemoveItem = (key: string): void => {
  sessionStorage.removeItem(key)
}
